import React from 'react';

import { Button } from '@mui/material';
import { Link } from 'react-router-dom';

import { en } from 'localization';
import { BrandEmblem, BrandWordmark } from 'shared-components/brand';

import {
  PublicContainer,
  PublicSiteHeaderActions,
  PublicSiteHeaderBar,
  PublicSiteHeaderEmblem,
  PublicSiteHeaderHomeLink,
  PublicSiteHeaderRow,
  PublicSiteHeaderWordmark,
  PublicSiteSecondaryCta,
} from './public-page-shell.styled-components';
import { useRevealOnScrollPast } from './use-reveal-on-scroll-past';

const copy = en.publicShell.header;

interface PublicSiteHeaderProps {
  openRoles?: 'show' | 'hide' | 'on-scroll';
  revealAfterRef?: React.RefObject<Element>;
}

export const PublicSiteHeader: React.FC<PublicSiteHeaderProps> = ({
  openRoles = 'show',
  revealAfterRef,
}) => {
  const fallbackRef = React.useRef<Element>(null);
  const watchRef = revealAfterRef ?? fallbackRef;
  const scrolledPast = useRevealOnScrollPast(watchRef);

  const showOpenRoles =
    openRoles === 'show' || (openRoles === 'on-scroll' && scrolledPast);

  return (
    <PublicSiteHeaderBar>
      <PublicContainer>
        <PublicSiteHeaderRow>
          <PublicSiteHeaderHomeLink
            aria-label={en.brand.appName}
            as={Link}
            to="/"
          >
            <PublicSiteHeaderWordmark>
              <BrandWordmark />
            </PublicSiteHeaderWordmark>

            <PublicSiteHeaderEmblem>
              <BrandEmblem />
            </PublicSiteHeaderEmblem>
          </PublicSiteHeaderHomeLink>

          <PublicSiteHeaderActions aria-label={copy.navLabel}>
            {showOpenRoles ? (
              <PublicSiteSecondaryCta component={Link} to="/jobs">
                {copy.openRoles}
              </PublicSiteSecondaryCta>
            ) : null}

            <Button
              color="primary"
              component={Link}
              disableRipple
              to="/client"
              variant="contained"
            >
              {copy.imHiring}
            </Button>
          </PublicSiteHeaderActions>
        </PublicSiteHeaderRow>
      </PublicContainer>
    </PublicSiteHeaderBar>
  );
};
